import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { FC, useState } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

import api from "../../../../api";
import { AdvertiserType } from "../../../../types/advertiserTypes";

type ArchiveAdvertiserModalProps = {
  advertiser: AdvertiserType;
  onClose: () => void;
  onSuccess: () => void;
};

const ErrorText = styled("p")(({ theme }: { theme: Theme }) => ({
  color: theme.palette.brand.errorRed,
  fontSize: 13,
  marginTop: 8,
  marginBottom: 0,
}));

const ArchiveAdvertiserModal: FC<ArchiveAdvertiserModalProps> = ({ advertiser, onClose, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleArchive = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await api.archiveAdvertiser(advertiser.brandgenAdvertiserId);
      if (result.success) {
        onSuccess();
        onClose();
      } else {
        const message = result.error ?? "Unable to archive advertiser.";
        if (message.includes("active campaigns")) {
          setError(
            "This advertiser has active campaigns. Archive or pause all campaigns before archiving the advertiser.",
          );
        } else {
          setError(message);
        }
      }
    } catch {
      setError("An unexpected error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open onClose={onClose} aria-labelledby="archive-dialog-title" fullWidth maxWidth="sm">
      <DialogTitle id="archive-dialog-title">Archive Advertiser</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Archiving <strong>{advertiser.name}</strong> will hide it from the active advertisers list. This action is
          blocked if the advertiser has active campaigns.
        </DialogContentText>
        {error ? <ErrorText>{error}</ErrorText> : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={handleArchive} color="primary" disabled={isLoading}>
          {isLoading ? "Archiving…" : "Archive"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ArchiveAdvertiserModal;
